export type ICityBrandUrlParams = {
    citySlug: string
    brandSlug: string
}

export class CityBrandRoute {
    static createUrl = (params: ICityBrandUrlParams) =>
        `/restaurants/${params.citySlug}/brands/${params.brandSlug}`
}

export class CityBrandsRoute {
    static createUrl = (params: { citySlug: string }) => `/restaurants/${params.citySlug}/brands`
}
